/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_ConflictInputs */

const fr_api_conflict = /** @type {(inputs: Api_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette modification entre en conflit avec les données actuelles. Actualisez la fiche.`)
};

const en_api_conflict = /** @type {(inputs: Api_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This change conflicts with the current data. Refresh the record.`)
};

/**
* | output |
* | --- |
* | "This change conflicts with the current data. Refresh the record." |
*
* @param {Api_ConflictInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_conflict = /** @type {((inputs?: Api_ConflictInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_ConflictInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_conflict(inputs)
	return fr_api_conflict(inputs)
});